export const milestones = [
  {
    year: "2017",
    title: "The Seed",
    body: "Verdant began as a conversation between two textile scientists and a Portuguese farmer who believed cotton could heal soil. The first six garments were cut by hand in a converted barn outside Braga.",
  },
  {
    year: "2019",
    title: "The Mill",
    body: "We partnered with a family-run mill on the Douro River, the first in Portugal to run entirely on hydroelectric power. This became the beating heart of our supply chain.",
  },
  {
    year: "2021",
    title: "Profit Share",
    body: "Every tailor, dyer, and packer in our network became a profit-share partner. No one who touches a Verdant garment earns less than a living wage.",
  },
  {
    year: "2023",
    title: "Carbon Negative",
    body: "Through regenerative farming and rewilding partnerships, we began sequestering more carbon than our entire operation emits. We are now certified carbon negative.",
  },
  {
    year: "2025",
    title: "Circular at Scale",
    body: "Our take-back program reached 10,000 garments. Every returned piece is either repaired for resale, upcycled into new designs, or composted into the fields that grow next season's fibers.",
  },
];

export const teamMembers = [
  {
    name: "Margarida Ferreira",
    role: "Founder & Creative Director",
    image:
      "https://readdy.ai/api/search-image?query=portrait%20of%20confident%20woman%20creative%20director%20in%20natural%20light%20atelier%20studio%2C%20warm%20earth%20tone%20clothing%2C%20soft%20window%20light%2C%20sustainable%20fashion%20designer%20editorial%20portrait%2C%20cream%20linen%20backdrop%2C%20intimate%20warm%20mood%2C%20authentic%20expression&width=600&height=750&seq=verdant-team-1&orientation=portrait",
    quote: "Clothes should outlive the person who makes them, and the person who wears them.",
  },
  {
    name: "Tomás Oliveira",
    role: "Head of Regenerative Materials",
    image:
      "https://readdy.ai/api/search-image?query=portrait%20of%20thoughtful%20man%20textile%20scientist%20in%20natural%20light%20workshop%2C%20earth%20tone%20clothing%2C%20soft%20warm%20light%2C%20sustainable%20material%20researcher%20editorial%20portrait%2C%20cream%20linen%20backdrop%2C%20genuine%20warm%20expression%2C%20artisanal%20setting&width=600&height=750&seq=verdant-team-2&orientation=portrait",
    quote: "The fiber is the message. Every thread carries the story of the soil it came from.",
  },
  {
    name: "Inês Sousa",
    role: "Master Tailor & Atelier Lead",
    image:
      "https://readdy.ai/api/search-image?query=portrait%20of%20skilled%20woman%20artisan%20tailor%20in%20warm%20natural%20light%20sewing%20studio%2C%20earth%20tone%20linen%20apron%2C%20soft%20golden%20light%2C%20sustainable%20craftswoman%20editorial%20portrait%2C%20cream%20backdrop%2C%20warm%20authentic%20expression%2C%20artisanal%20mood&width=600&height=750&seq=verdant-team-3&orientation=portrait",
    quote: "I have sewn for twenty-three years. A Verdant garment takes three times longer. That is the difference.",
  },
];

export const storyValues = [
  {
    icon: "ri-seedling-line",
    title: "Soil First",
    body: "We choose fibers that restore the land they grow on. Regenerative cotton, rotational flax, and peace silk are not alternatives — they are our standard.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Hands Matter",
    body: "Every person in our chain earns a living wage and a share of profits. We publish our full cost breakdown because transparency is not a trend.",
  },
  {
    icon: "ri-time-line",
    title: "Time is Material",
    body: "A Verdant garment takes an average of 47 hours from fiber to finish. Fast fashion takes 15 minutes. We believe the difference is visible, wearable, and worth it.",
  },
];